import { PHOTO_SIZE_HINT } from "../../js/utils/imageCompress";

export default function PhotoSizeHint({ className = "field-hint photo-size-hint" }) {
  return <p className={className}>{PHOTO_SIZE_HINT}</p>;
}
